<template>
    <div>
        <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn :class="classBtn"
                    width="40"
                    max-width="40"
                    min-width="40"
                    depressed
                    :loading="loading"
                    v-bind="attrs"
                    v-on="on"
                    :ripple="false"
                    @click="$emit('click')"
                >
                    <v-icon color="inverse">{{icon}}</v-icon>
                </v-btn>
            </template>
            <div class="d-flex align-center">
                <v-icon class="mr-1" color="inverse">mdi-hand-pointing-right</v-icon>
                <h1 class="text-body-subtitle-inverse">{{smsTooltip}}</h1>
            </div>
        </v-tooltip>
    </div>
</template>
<script>
export default {
    props: {
        icon: String,
        smsTooltip: String,
        classBtn: {
            default: 'primary',
            type: String
        },
        loading: Boolean
    }
}
</script>
